/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Reset_FiltersInputs */

const en_admin_resources_reset_filters = /** @type {(inputs: Admin_Resources_Reset_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear`)
};

const de_admin_resources_reset_filters = /** @type {(inputs: Admin_Resources_Reset_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter zurücksetzen`)
};

const es_admin_resources_reset_filters = /** @type {(inputs: Admin_Resources_Reset_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reiniciar filtros`)
};

const fr_admin_resources_reset_filters = /** @type {(inputs: Admin_Resources_Reset_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réinitialiser les filtres`)
};

const nl_admin_resources_reset_filters = /** @type {(inputs: Admin_Resources_Reset_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wissen`)
};

/** @type {(inputs: Admin_Resources_Reset_FiltersInputs) => LocalizedString} */
const it_admin_resources_reset_filters = en_admin_resources_reset_filters;

/** @type {(inputs: Admin_Resources_Reset_FiltersInputs) => LocalizedString} */
const pt_br2_admin_resources_reset_filters = en_admin_resources_reset_filters;

/** @type {(inputs: Admin_Resources_Reset_FiltersInputs) => LocalizedString} */
const pl_admin_resources_reset_filters = en_admin_resources_reset_filters;

/** @type {(inputs: Admin_Resources_Reset_FiltersInputs) => LocalizedString} */
const hu_admin_resources_reset_filters = en_admin_resources_reset_filters;

/** @type {(inputs: Admin_Resources_Reset_FiltersInputs) => LocalizedString} */
const ro_admin_resources_reset_filters = en_admin_resources_reset_filters;

/**
* | output |
* | --- |
* | "Clear" |
*
* @param {Admin_Resources_Reset_FiltersInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_reset_filters = /** @type {((inputs?: Admin_Resources_Reset_FiltersInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Reset_FiltersInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_reset_filters(inputs)
	if (locale === "de") return de_admin_resources_reset_filters(inputs)
	if (locale === "es") return es_admin_resources_reset_filters(inputs)
	if (locale === "fr") return fr_admin_resources_reset_filters(inputs)
	if (locale === "nl") return nl_admin_resources_reset_filters(inputs)
	if (locale === "it") return it_admin_resources_reset_filters(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_reset_filters(inputs)
	if (locale === "pl") return pl_admin_resources_reset_filters(inputs)
	if (locale === "hu") return hu_admin_resources_reset_filters(inputs)
	return ro_admin_resources_reset_filters(inputs)
});
export { admin_resources_reset_filters as "admin.resources.reset_filters" }